import { render, staticRenderFns } from "./cart-head.vue?vue&type=template&id=1b51c6a2&"
import script from "./cart-head.vue?vue&type=script&lang=js&"
export * from "./cart-head.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports